import { createContext, useContext, useMemo } from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
export const BadgeContext = /*#__PURE__*/createContext(undefined);
export const BadgeProvider = ({
  badgeStyleOverrides,
  children
}) => {
  const value = useMemo(() => ({
    badgeStyleOverrides
  }), [badgeStyleOverrides]);
  return /*#__PURE__*/_jsx(BadgeContext.Provider, {
    value: value,
    children: children
  });
};

/**
 * Provides the context for the `Badge` component.
 * Note: The context is only available when the `Badge` component is rendered as an ancestor.
 * @returns BadgeContext - The context for the `Badge` component.
 * @returns BadgeContext.badgeStyleOverrides - Style overrides to be applied to the `View` component within the `Badge` component.
 */
export const useBadgeContext = () => {
  const badgeContext = useContext(BadgeContext);
  return badgeContext;
};